import { tbEase } from "./tbEase";
var tbAnimator = /** @class */ (function () {
    function tbAnimator(target, tracks, events) {
        this.duration = 0; // The total duration of the animator
        this.currentTime = 0; // Current time in milliseconds (or whatever the user uses)
        this.looping = false; // Whether to loop the global animator
        this.paused = 0; // How often paused
        this.speed = 1; // The speed (multiplication factor)
        this.tracks = [];
        this.events = [];
        this.target = target;
        if (tracks !== undefined) {
            this.addTracks(tracks);
        }
        if (events !== undefined) {
            this.addEvents(events);
        }
    }
    tbAnimator.prototype.addEvents = function (events) {
        events = [].concat(events);
        for (var i = 0; i < events.length; i += 1) {
            this.addEvent(events[i].target, events[i].time, events[i].callback, events[i].arg);
        }
    };
    tbAnimator.prototype.addEvent = function (target, time, callback, arg) {
        var result;
        this.events.push({ target: target, time: time, callback: callback, arg: arg });
        result = this.events[this.events.length - 1];
        this._sortEvents();
        this._computeDuration();
        return result;
    };
    tbAnimator.prototype.removeEvents = function (startTime, endTime) {
        if (startTime === void 0) { startTime = -99999999; }
        if (endTime === void 0) { endTime = 99999999; }
        for (var i = this.events.length - 1; i >= 0; i -= 1) {
            if (this.events[i].time >= startTime && this.events[i].time <= endTime) {
                this.events.splice(i);
            }
        }
        this._computeDuration();
    };
    tbAnimator.prototype._sortEvents = function () {
        this.events.sort(function (a, b) { return a.time - b.time; });
    };
    tbAnimator.prototype.addTracks = function (tracks) {
        if (tracks !== undefined) {
            tracks = [].concat(tracks);
            for (var i = 0; i < tracks.length; i += 1) {
                this.addTrack(tracks[i].kind, tracks[i].target, tracks[i].func, tracks[i].arg, tracks[i].keys);
            }
        }
    };
    tbAnimator.prototype.addTrack = function (kind, target, func, arg, keys) {
        var result;
        this.tracks.push({ kind: kind, target: target, func: func, arg: arg, keys: [], looping: false, rounding: "none", onlyChanged: true, lastValue: undefined });
        result = this.tracks[this.tracks.length - 1];
        if (keys !== undefined) {
            this.addKeys(result, keys);
        }
        return result;
    };
    tbAnimator.prototype.removeTrack = function (track) {
        var ind = this.tracks.indexOf(track);
        if (ind < 0) {
            return;
        }
        this.tracks.splice(ind);
    };
    tbAnimator.prototype.removeAllTracks = function () {
        this.tracks = [];
    };
    tbAnimator.prototype.setTrackLooping = function (track, looping) {
        track.looping = looping;
    };
    tbAnimator.prototype.setTrackRounding = function (track, rounding) {
        track.rounding = rounding;
    };
    tbAnimator.prototype.setTrackOnlyChanged = function (track, onlyChanged) {
        track.onlyChanged = onlyChanged;
    };
    tbAnimator.prototype.getTrackDuration = function (track) {
        if (track.keys.length === 0) {
            return 0;
        }
        return track.keys[track.keys.length - 1].time;
    };
    tbAnimator.prototype._computeDuration = function () {
        var i;
        this.duration = 0;
        for (i = 0; i < this.tracks.length; i += 1) {
            this.duration = Math.max(this.duration, this.getTrackDuration(this.tracks[i]));
        }
        this.duration = Math.max(this.duration, this.getEventsDuration());
    };
    tbAnimator.prototype.getEventsDuration = function () {
        if (this.events.length === 0) {
            return 0;
        }
        return this.events[this.events.length - 1].time;
    };
    tbAnimator.prototype.getTrackValue = function (track, time) {
        var theValue, len, ind, key1, key2;
        len = track.keys.length;
        if (len === 0) {
            return 0;
        }
        // Deal with looping
        if (track.looping) {
            time = time % track.keys[len - 1].time;
            if (time < 0) {
                time += track.keys[len - 1].time;
            }
        }
        // Find the value
        if (time <= track.keys[0].time) {
            theValue = track.keys[0].value;
        }
        else if (time >= track.keys[len - 1].time) {
            theValue = track.keys[len - 1].value;
        }
        else {
            ind = 0;
            while (track.keys[ind].time < time) {
                ind += 1;
            }
            key1 = track.keys[ind - 1];
            key2 = track.keys[ind];
            theValue = key1.ease(time - key1.time, key1.value, key2.value - key1.value, key2.time - key1.time, key1.arg);
        }
        // Deal with rounding
        switch (track.rounding) {
            case "round":
                theValue = Math.round(theValue);
                break;
            case "floor":
                theValue = Math.floor(theValue);
                break;
            case "ceil":
                theValue = Math.ceil(theValue);
                break;
        }
        // Ready
        return theValue;
    };
    tbAnimator.prototype._applyValue = function (track, time) {
        var theValue, target;
        if (track.keys.length === 0) {
            return;
        }
        theValue = this.getTrackValue(track, time);
        // Check whether changed
        if (theValue === track.lastValue && track.onlyChanged) {
            return;
        }
        // Apply the value
        target = track.target === undefined ? this.target : track.target;
        if (target === undefined && track.kind !== "function") {
            return;
        }
        switch (track.kind) {
            case "image":
                target.image = theValue;
                break;
            case "subImage":
                target.subImage = theValue;
                break;
            case "alpha":
                target.alpha = theValue;
                break;
            case "xScale":
                target.xScale = theValue;
                break;
            case "yScale":
                target.yScale = theValue;
                break;
            case "scale":
                target.scale = theValue;
                break;
            case "angle":
                target.angle = theValue;
                break;
            case "x":
                target.x = theValue;
                break;
            case "y":
                target.y = theValue;
                break;
            case "speed":
                target.speed = theValue;
                break;
            case "function":
                if (target === undefined) {
                    track.func(theValue, track.arg);
                }
                else {
                    track.func.call(target, theValue, track.arg);
                }
                break;
        }
    };
    tbAnimator.prototype.addKeys = function (track, keys) {
        if (keys !== undefined) {
            keys = [].concat(keys);
            for (var i = 0; i < keys.length; i += 1) {
                this.addKey(track, keys[i].time, keys[i].value, keys[i].ease, keys[i].arg);
            }
        }
    };
    tbAnimator.prototype.addKey = function (track, time, value, ease, easingModifierValue, arg) {
        var result;
        if (ease === undefined) {
            ease = tbEase.easeLinear;
        }
        track.keys.push({ time: time, value: value, ease: ease, arg: arg });
        result = track.keys[track.keys.length - 1];
        this._sortKeys(track);
        this._computeDuration();
        return result;
    };
    tbAnimator.prototype._sortKeys = function (track) {
        track.keys.sort(function (a, b) { return a.time - b.time; });
    };
    tbAnimator.prototype.appendKeys = function (track, keys) {
        if (keys !== undefined) {
            keys = [].concat(keys);
            for (var i = 0; i < keys.length; i += 1) {
                this.appendKey(track, keys[i].time, keys[i].value, keys[i].ease, keys[i].arg);
            }
        }
    };
    tbAnimator.prototype.appendKey = function (track, time, value, ease, arg) {
        var result, lastTime;
        lastTime = track.keys.length === 0 ? 0 : track.keys[track.keys.length - 1].time;
        if (ease === undefined) {
            ease = tbEase.easeLinear;
        }
        track.keys.push({ time: lastTime + time, value: value, ease: ease, arg: arg });
        result = track.keys[track.keys.length - 1];
        this._computeDuration();
        return result;
    };
    tbAnimator.prototype.removeKey = function (track, key) {
        var ind = track.indexOf(key);
        if (ind < 0) {
            return;
        }
        track.splice(ind);
        this._computeDuration();
    };
    tbAnimator.prototype.removeKeys = function (track, startTime, endTime) {
        if (startTime === undefined) {
            startTime = -99999999;
        }
        if (endTime === undefined) {
            endTime = 99999999;
        }
        for (var i = track.keys.length - 1; i >= 0; i -= 1) {
            if (track.keys[i].time >= startTime && track.keys[i].time <= endTime) {
                track.keys.splice(i);
            }
        }
        this._computeDuration();
    };
    tbAnimator.prototype.removeAllKeys = function (startTime, endTime) {
        for (var i = 0; i < this.tracks.length; i += 1) {
            this.removeKeys(this.tracks[i], startTime, endTime);
        }
    };
    tbAnimator.prototype.resume = function () {
        this.paused--;
    };
    tbAnimator.prototype.resumeForced = function () {
        this.paused = 0;
    };
    tbAnimator.prototype.pause = function () {
        this.paused++;
    };
    tbAnimator.prototype.isPause = function () {
        return this.paused > 0;
    };
    tbAnimator.prototype.setSpeed = function (speed) {
        this.speed = speed;
    };
    tbAnimator.prototype.getSpeed = function () {
        return this.speed;
    };
    tbAnimator.prototype.getDuration = function () {
        return this.duration;
    };
    tbAnimator.prototype.setTime = function (newTime, noChange) {
        if (noChange === void 0) { noChange = false; }
        this.currentTime = this._correctTime(newTime);
        if (noChange) {
            return;
        }
        for (var i = 0; i < this.tracks.length; i += 1) {
            this._applyValue(this.tracks[i], this.currentTime);
        }
    };
    tbAnimator.prototype._correctTime = function (time) {
        if (this.looping) {
            time = time % this.duration;
            if (time < 0) {
                time += this.duration;
            }
        }
        else {
            time = Math.max(0, Math.min(this.duration, time));
        }
        return time;
    };
    tbAnimator.prototype.updateTime = function (timePassed) {
        var newTime, events, i;
        if (this.paused > 0) {
            return;
        }
        // Compute the new time
        newTime = this._correctTime(this.currentTime + this.speed * timePassed);
        // Handle events
        events = this._findEvents(this.currentTime, newTime);
        for (i = 0; i < events.length; i += 1) {
            this.setTime(events[i].time);
            if (this._executeEvent(events[i])) {
                this.currentTime = events[i].time - 0.0000001 * Math.sign(this.speed); // To make sure it is tested again the next step
                return;
            }
        }
        // Set the new time
        this.setTime(newTime);
    };
    tbAnimator.prototype.setLooping = function (looping) {
        this.looping = looping;
    };
    tbAnimator.prototype._executeEvent = function (event) {
        var target, result;
        target = event.target === undefined ? this.target : event.target;
        if (target === undefined) {
            result = event.callback(event.arg);
        }
        else {
            result = event.callback.call(target, event.arg);
        }
        return result;
    };
    tbAnimator.prototype._findEvents = function (startTime, endTime) {
        var i, result = [];
        if (this.speed > 0) {
            if (endTime >= startTime) {
                for (i = 0; i < this.events.length; i += 1) {
                    if (this.events[i].time > startTime && this.events[i].time <= endTime) {
                        result.push(this.events[i]);
                    }
                }
            }
            else {
                for (i = 0; i < this.events.length; i += 1) {
                    if (this.events[i].time > startTime) {
                        result.push(this.events[i]);
                    }
                }
                for (i = 0; i < this.events.length; i += 1) {
                    if (this.events[i].time <= endTime) {
                        result.push(this.events[i]);
                    }
                }
            }
        }
        else {
            if (endTime <= startTime) {
                for (i = this.events.length - 1; i >= 0; i -= 1) {
                    if (this.events[i].time < startTime && this.events[i].time >= endTime) {
                        result.push(this.events[i]);
                    }
                }
            }
            else {
                for (i = this.events.length - 1; i >= 0; i -= 1) {
                    if (this.events[i].time < startTime) {
                        result.push(this.events[i]);
                    }
                }
                for (i = this.events.length - 1; i >= 0; i -= 1) {
                    if (this.events[i].time >= endTime) {
                        result.push(this.events[i]);
                    }
                }
            }
        }
        return result;
    };
    return tbAnimator;
}());
export { tbAnimator };
